
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Prop()
  private ifCompose: any;
  private get c() {
    if (!this.data.value) {
      this.data.value = [];
    }
    this.$forceUpdate();
    return this.data;
  }
  private set c(val) {
    console.log("ddd");
    console.log(val);
    this.$emit("update", val);
  }
}
